export const owner = "owner";
export const single = "single";
export const admin = "admin";
export const standard = "standard";